<template>
  <Wrapper>
    <main class="main">
      <h1 class="title">{{ Login.title[lang] }}</h1>
      <form action="/" class="login-form" @submit.prevent="onLogin">
        <dl class="login-form__dl">
          <dt class="login-form__dl--dt"> ID </dt>
          <dd class="login-form__dl--dd">
            {{ Login.id_description[lang] }}
          </dd>
          <dd class="login-form__dl--dd">
            <label>
              <input
                v-model="loginId"
                type="text"
                placeholder="ID"
                class="login-id"
              />
            </label>
          </dd>
        </dl>
        <dl class="login-form__dl">
          <dt class="login-form__dl--dt">{{ Login.password[lang] }}</dt>
          <dd class="login-form__dl--dd">
            {{ Login.password_description[lang] }}
          </dd>
          <dd class="login-form__dl--dd">
            <label>
              <input
                v-model="loginPassword"
                type="password"
                :placeholder="Login.password[lang]"
                class="login-pw"
              />
            </label>
          </dd>
        </dl>
        <button type="submit" class="login-form__button">
          {{ Login.login[lang] }}
        </button>
      </form>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../../components/sp/Wrapper";
import Login from "../../../../assets/constants/company/login.json";
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
export default {
  data() {
    return {
      loginId: "",
      loginPassword: "",
    };
  },
  methods: {
    onLogin: function () {
      // 認証に必要な情報を作る
      const authenticationDetails = new AuthenticationDetails({
        Username: this.loginId,
        Password: this.loginPassword,
      });
      // ユーザー情報を作る
      const userPool = new CognitoUserPool({
        UserPoolId: process.env.COGNITO.USER_POOL_ID,
        ClientId: process.env.COGNITO.CLIENT_ID,
      });
      const cognitoUser = new CognitoUser({
        Username: this.loginId,
        Pool: userPool,
      });

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: () => {
          this.$router.push("/company/summary");
        },
        onFailure: (err) => {
          if (
            err.code === "NotAuthorizedException" ||
            err.code === "ResourceNotFoundException"
          ) {
            return alert(this.Login.error.not_authorized[this.lang]);
          } else if (err.code === "UserNotConfirmedException") {
            return alert(this.Login.error.user_not_confirmed[this.lang]);
          } else if (err.code === "InvalidParameterException") {
            return alert(this.Login.error.invalid_parameter[this.lang]);
          } else if (err.code === "UserNotFoundException") {
            return alert(this.Login.error.user_not_found[this.lang]);
          }
        },
      });
    },
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
    Login: function () {
      return Login;
    },
  },
  components: {
    Wrapper,
  },
  name: "SpLogin",
};
</script>

<style scoped>
.main {
  min-height: calc(100vh - 175px);
  .title {
    margin: 60px 0 0 0;
  }
  .login-form {
    padding: 60px 0;
    &__dl {
      &:not(:first-of-type) {
        margin: 20px 0 0 0;
      }

      &--dt {
        margin: 25px 0 0 0;
        font-size: 16px;
        font-weight: bold;
        color: var(--defaultBlackColor);
      }

      &--dd {
        margin: 10px 0 0 0;
        font-size: 14px;

        .login-id,
        .login-pw {
          width: 100%;
          height: 48px;
          padding: 0 0 0 10px;
          font-size: 16px;
          border: solid 1px var(--grayColor3);
          outline-color: var(--grayColor3);
          background-color: var(--defaultWhiteColor);
        }

        .alert {
          background-color: var(--alertColor2);
          border: 1px solid var(--alertColor);
        }
      }
    }
    &__button {
      margin: 60px 0 0 0;
      width: 100%;
      height: 58px;
      font-size: 20px;
      color: var(--defaultBlackColor);
      border: solid 2px var(--defaultBlackColor);
      background-color: var(--defaultWhiteColor);
      &:hover {
        color: var(--defaultWhiteColor);
        border: solid 2px var(--defaultBlackColor);
        background-color: var(--defaultBlackColor);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/company/login/Login.vue